import styled from 'styled-components';

import { Select } from 'antd';

export const OrderSelect = styled(Select)`
  width: 120px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
`;